// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__ttoqG","head":"Table_head__1smnL","col":"Table_col__1V-vJ"};